import React from 'react';
import { APPEARANCES, Heading } from '../PageElements/Heading';
import style from './SectionContainer.scss';

export const SectionContainer = ({
  title,
  children,
  className = '',
  titleDataHook = '',
}) => (
  <div className={`${style.sectionContainer} ${className}`}>
    {title && (
      <Heading appearance={APPEARANCES.H3} dataHook={titleDataHook}>
        {title}
      </Heading>
    )}
    {children}
  </div>
);
